<!-- Component can be used in microscope and periscope -->
<template>
  <div ref="qr"></div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import QRCode from 'qrcode-svg'

const props = defineProps<{
  token?: string
}>()

const qr = ref<HTMLDivElement | undefined>()

watch(
  () => props.token,
  () => {
    if (!props.token || !qr.value) {
      return
    }

    const qrCode = new QRCode({
      content: props.token,
      padding: 4,
      width: 256,
      height: 256,
      color: '#000000',
      background: '#ffffff',
      ecl: 'M',
    })

    qr.value.innerHTML = qrCode.svg()
  },
  { immediate: true },
)
</script>
